import { Token, tokens } from "@/config/tokens"
import { TokenIcon } from "@/components/token"
import { FormControl } from "@/components/ui/form"
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"

interface TokenSelectProps {
  onChange: (value: string) => void;
  defaultValue: Token;
  exclude?: Token[];
}

export default function TokenSelect({
  onChange,
  defaultValue,
  exclude = [],
}: TokenSelectProps) {
  return (
    <Select onValueChange={onChange} defaultValue={defaultValue}>
      <FormControl>
        <SelectTrigger>
          <SelectValue placeholder="Token" />
        </SelectTrigger>
      </FormControl>
      <SelectContent>
        {Object.entries(tokens).map(([key, token]) => (
          <SelectItem
            key={token.symbol}
            value={token.symbol}
            disabled={exclude.includes(token.symbol)}
          >
            <div className="flex flex-row gap-2 items-center">
              {<TokenIcon name={key as Token} />}
              {token.name}
            </div>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
